module.exports = {"469022100":"屯城镇","469022101":"新兴镇","469022102":"枫木镇","469022103":"乌坡镇","469022104":"南吕镇","469022105":"南坤镇","469022106":"坡心镇","469022107":"西昌镇","469022400":"国营中建农场","469022401":"国营中坤农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469022.json
// module id = 2026
// module chunks = 0